import { Result, Spin } from "antd";
import { StoreContext } from "contexts";
import { ordersHooks } from "hooks";
import { IPlatform } from "models";
import React, { useContext } from "react";
import { Trans } from "react-i18next";

export interface WithPlatformPermissionProps {
  authorizedPlatforms: IPlatform[];
  isFetching?: boolean;
}

export const withPlatformPermission = <P extends {}>(
  Component: React.FC<P>,
  targetTitle: string
): React.FC<P & WithPlatformPermissionProps> => {
  return (props) => {
    const { authorizedPlatforms, isFetching, userPlatformId } = ordersHooks.useAuthorizedPlatforms();
    const { currentUser } = useContext(StoreContext);
    const userIdentity = currentUser.email || currentUser.phone_number || currentUser.name;

    if (isFetching) return <Spin spinning={isFetching} />;

    // If the user's platform permissions is not set
    if (Number.isNaN(userPlatformId) || (authorizedPlatforms && authorizedPlatforms.length === 0)) {
      return (
        <Result
          status="403"
          subTitle={
            <Trans i18nKey="InvalidUserPlatformMsg">
              Tài khoản <span className="text-primary text-medium"> {{ userIdentity }} </span> chưa được gán Platform
              hợp lệ để xem {{ targetTitle: targetTitle.toLowerCase() }}.
              <br /> Vui lòng liên hệ Admin <a href="mailto:support@teko.vn">support@teko.vn</a>
              để được hỗ trợ.
            </Trans>
          }
        />
      );
    }

    return <Component {...props} authorizedPlatforms={authorizedPlatforms} isFetching={isFetching} />;
  };
};
